import React, { Fragment } from 'react'

import useRedux from '../../../../../hooks/useRedux'
import useTranslations from '../../../../../hooks/useTranslations'
import ANTDButton from '../../../../../shared/antd/ANTDButton'
import ANTDCard from '../../../../../shared/antd/ANTDCard'
import ANTDColumn from '../../../../../shared/antd/ANTDColumn'
import ANTDForm from '../../../../../shared/antd/ANTDForm'
import ANTDModal from '../../../../../shared/antd/ANTDModal'
import ANTDTable from '../../../../../shared/antd/ANTDTable'
import PopUpConfirm from '../../../../../shared/PopUpConfirm'
import { length } from '../../../../../utils/javascript'
import FormLayout from '../../../../common/presentation/FormLayout'
import childMotherTable from '../../../container/childMotherTable.container'

const ChildMotherTable = ({
  userType,
  filePath,
  hideAddButton = false,
  hideActionColumn = false,
  tableData,
  apiCall,
}) => {
  const { t } = useTranslations()
  const { selector } = useRedux()
  const isDesktop = selector(state => state.app.isDesktop)
  const {
    tableColumns,
    handleAddClick,
    isAddDisabled,
    rows,
    handleEditClick,
    handleViewClick,
    handleViewModalCancel,
    handleModalCancel,
    handleModalFinish,
    editingIndex,
    modalForm,
    formFieldAttributes,
    isModalOpen,
    isViewModalOpen,
    viewingRecord,
    getViewData,
    cardViewFn,
    handleTableChange,
    pagination,
    handleDeleteClick,
    deleteConfirmation,
    handleDeleteConfirm,
    handleDeleteCancel,
  } = childMotherTable({
    userType,
    filePath,
    hideActionColumn,
    tableData,
    apiCall,
  })

  return (
    <div>
      {!hideAddButton && (
        <div className="text-end mb-5">
          <ANTDButton
            type="primary"
            className="btn"
            onClick={handleAddClick}
            disabled={isAddDisabled}
          >
            {t('btn_Add')}
          </ANTDButton>
        </div>
      )}
      {!isDesktop ? (
        <div className="mt-20">
          {length(rows) ? (
            rows.map((item, index) => {
              const fileData = item?.imageDmsId?.fileList?.[0]
              const fileUrl =
                fileData?.thumbUrl || fileData?.url || fileData?.fileUrl
              return (
                <Fragment key={item.sNo || index}>
                  <ANTDCard
                    className="list-card-view"
                    title={null}
                    extra={
                      <div className="card-extra-buttons">
                        <ANTDButton
                          type="primary"
                          className="bg-view"
                          onClick={() => handleViewClick(item, index)}
                        >
                          {t('btn_View')}
                        </ANTDButton>
                        {!hideActionColumn && (
                          <>
                            <ANTDButton
                              type="primary"
                              className="bg-edit"
                              onClick={() => handleEditClick(item, index)}
                            >
                              {t('btn_Edit')}
                            </ANTDButton>
                            <ANTDButton
                              type="primary"
                              className="bg-danger"
                              onClick={() => handleDeleteClick(item, index)}
                            >
                              {t('btn_Delete')}
                            </ANTDButton>
                          </>
                        )}
                      </div>
                    }
                  >
                    <div className="card-details-container d-flex flex-wrap space-between flex-row-reverse">
                      <ANTDColumn sm={5} xs={24}>
                        <div className="card-img-wrap">
                          {fileUrl ? (
                            <img
                              src={fileUrl}
                              alt="child"
                              style={{
                                objectFit: 'cover',
                                borderRadius: '4px',
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: '100%',
                                height: '200px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                backgroundColor: '#f0f0f0',
                                borderRadius: '4px',
                              }}
                            >
                              <span>{t('user_Image')}</span>
                            </div>
                          )}
                        </div>
                      </ANTDColumn>
                      <ANTDColumn sm={19} xs={24}>
                        <div>
                          <table>
                            <tbody>
                              {cardViewFn(item)?.map(
                                ({ label, value }, idx) => (
                                  <tr key={idx}>
                                    <td className="card-table-label">
                                      <b>{t(label)}</b>
                                    </td>
                                    <td className="d-flex">
                                      <p>: </p>&nbsp;
                                      <p>{value || '-'}</p>
                                    </td>
                                  </tr>
                                ),
                              )}
                            </tbody>
                          </table>
                        </div>
                      </ANTDColumn>
                    </div>
                  </ANTDCard>
                </Fragment>
              )
            })
          ) : (
            <ANTDCard className="list-card-view">
              <h4 className="text-center">{t('txt_NoData')}</h4>
            </ANTDCard>
          )}
        </div>
      ) : (
        <ANTDTable
          className="job-table"
          columns={tableColumns({
            onEdit: handleEditClick,
            onView: handleViewClick,
            onDelete: handleDeleteClick,
          })}
          dataSource={rows}
          pagination={pagination}
          onChange={handleTableChange}
          scroll={{
            x: '100%',
          }}
        />
      )}

      <ANTDModal
        open={isModalOpen}
        onCancel={handleModalCancel}
        footer={null}
        destroyOnClose
        width={800}
        title={editingIndex !== null ? t('btn_Edit') : t('btn_Add')}
      >
        <ANTDForm
          form={modalForm}
          layout="vertical"
          onFinish={handleModalFinish}
        >
          <FormLayout
            form={modalForm}
            formFieldAttributes={formFieldAttributes}
          />
          <div className="text-center mt-20">
            <ANTDButton type="primary" className="btn" htmlType="submit">
              {editingIndex !== null ? t('btn_Update') : t('btn_Submit')}
            </ANTDButton>
          </div>
        </ANTDForm>
      </ANTDModal>

      <ANTDModal
        open={isViewModalOpen}
        onCancel={handleViewModalCancel}
        footer={null}
        destroyOnClose
        width={800}
        title={t('txt_Details')}
      >
        <div className="view-details-container">
          {viewingRecord &&
            getViewData(viewingRecord)?.map((item, index) => (
              <div key={index} className="view-details-row">
                <div className="view-label">
                  <b>{t(item.label)}:</b>
                </div>
                <div className="view-value">
                  {item.value?.type === 'images' ? (
                    <div className="d-flex flex-wrap">
                      {item.value.urls.map((url, idx) => (
                        <img
                          key={idx}
                          src={url}
                          alt={t(item.label)}
                          className="view-image"
                        />
                      ))}
                    </div>
                  ) : (
                    <span>{item.value}</span>
                  )}
                </div>
              </div>
            ))}
        </div>
      </ANTDModal>
      <PopUpConfirm
        isOpen={deleteConfirmation?.open}
        onCancelModel={handleDeleteCancel}
        onAccept={handleDeleteConfirm}
        onReject={handleDeleteCancel}
        description={t('msg_AreYouSureWantToRemove')}
      />
    </div>
  )
}

export default ChildMotherTable
